import React from 'react';

const ErrorScreen: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'sans-serif',
        flexDirection: 'column',
      }}
    >
      <h2>アクセスが拒否されました</h2>
      <p>{message || '権限がありません。管理者にお問い合わせください。'}</p>
    </div>
  );
};

export default ErrorScreen;
